import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchStaff } from '../../../store/actions/staffActions'
import InlinePreloader from '../../elements/InlinePreloader'
import AutocompleteSelect from '../../elements/form/AutocompleteSelect'
import ModalActionButton from '../../elements/ModalActionButton'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import { authHeader, baseUrl } from '../../../utils'
import axios from 'axios'

const AssignHouseParent = ({houseId, blockId, closeFunction}) => {
  const dispatch = useDispatch()
  const staffSelector = useSelector((state => state.staff))

  const [selectedParent, setSelectedParent] = useState(null)

  useEffect(() => {
    dispatch(fetchStaff(`onboarded=true`, 0, 0))
  
    return () => {
      
    }
  }, [dispatch])

  const [validationErrors, setValidationErrors] = useState({})

  const validateForm = () => {
      let errors = {}

      if(!selectedParent || selectedParent === ''){
          errors.parent = true
      }
      setValidationErrors(errors)
  
      return errors
  }

  const [processing, setProcessing] = useState(false)

  const assignParent = async () => {
    if (Object.values(validateForm()).includes(true)) {
      dispatch({
        type: ERROR,
        error: {response: {data: {
            message: 'Please check the highlighted fields'
        }}}
      })
      return
    }

    const payload = {
      house: houseId,
      houseBlock: blockId,
      staff: selectedParent
    }

    try{
      const headers = authHeader()

      setProcessing(true)

      await axios.post(`${baseUrl}/student-housing/house-blocks/assign-house-parents`, payload, { headers })
      
      dispatch({
          type: SET_SUCCESS,
          payload: `House parent assigned successfully`
      })
      setProcessing(false)
      closeFunction()        
    }
    catch(error){
      dispatch({
          type: ERROR,
          error
      })
      setProcessing(false)
      closeFunction()
    }
  }

  return (
    <div>
          {staffSelector?.loadingStaff 
            ? 
              <InlinePreloader />
            : 
              <>
                {staffSelector?.staffMembers?.staff?.length > 0 && <div className='mt-4 relative'>
                  <AutocompleteSelect
                    selectOptions = {staffSelector?.staffMembers?.staff}
                    inputLabel = "House Parent"
                    requiredField={true}
                    titleField = "fullName"
                    displayImage = {false}
                    imageField = ""
                    placeholderText={`Select a member of staff`}
                    fieldId = {`house-parent`}
                    preSelected={selectedParent || ''}
                    preSelectedLabel='_id'
                    hasError = {validationErrors && validationErrors.parent}
                    returnFieldValue={(value)=>{setSelectedParent(value._id)}}
                  />
                </div>}
                
                {staffSelector?.staffMembers?.staff?.length === 0 && 
                  <div className='w-full mt-[20px] p-[15px] bg-gray-50 border border-gray-400 rounded-[8px] bg-opacity-'>
                    <h3 className='text-sm text-gray-600 font-[500] tracking-tight'>No eligible staff found</h3>
                    <p className='text-sm font-[500] text-gray-500'>The staff must be fully onboarded on this system and be enrolled as a full time employee</p>
                  </div>
                }
              </>
            }

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Assign house parent`}
                    buttonAction={()=>{assignParent()}}
                    processing={processing}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Close
                </button>
                
            </div>
    </div>
  )
}

export default AssignHouseParent
